const HiddenField = ({ input }) => (
  <div style={{ display: 'none' }}>
    <input {...input} type='hidden' />
  </div>
);

export default HiddenField;
